import { Overlay } from 'Shared/frontend/Overlay';
import { Component } from 'Shared/frontend/widgets/Component';
import { Show,createSignal } from 'solid-js';

export function Popup(P)
{
	const [overlay,setOverlay] = createSignal(true);

//FIXME close button is impinging on content

	return (
		<Show when={overlay()}>
			<Overlay animation='fadeIn' close={() => setOverlay(false)}>
				<Component {...P.content} />
			</Overlay>
		</Show>
	);
}

